/**
 * Ruta `/regularizar/$markId` (007 · T035; contracts/ui.md §1.4): formulario para proponer la hora
 * que falta de la marca ancla `markId`.
 *
 * `RegularizeGate` = `useAccessGate({ allowSuspended: false })`: con la empresa suspendida la
 * puerta manda a `/servicio-suspendido` (proponer está prohibido; consultar se hace desde
 * Asistencia). Sin barra de pestañas: es una pantalla de tarea, como `/marcar`. El `markId` es
 * opaco: si no corresponde a un ítem del trabajador, la pantalla dice "Esta marca ya no se puede
 * regularizar" (la API respondería `404` indistinguible).
 */
import { createFileRoute } from '@tanstack/react-router';

import { GenericErrorScreen } from '../components/ui/generic-error';
import { OfflineState } from '../components/ui/offline-state';
import { Screen } from '../components/ui/screen';
import { PrivacyUpdateScreen } from '../features/access/privacy-update';
import { RegularizeLoading, RegularizeScreen } from '../features/regularization/regularize-screen';
import { useAccessGate } from '../features/shell/use-access-gate';

export function RegularizeGate() {
  const { markId } = Route.useParams();
  const gate = useAccessGate({ allowSuspended: false });

  if (gate.status === 'LOADING') {
    return <RegularizeLoading />;
  }
  if (gate.status === 'OFFLINE') {
    return (
      <Screen>
        <OfflineState onRetry={gate.retry} />
      </Screen>
    );
  }
  if (gate.status === 'ERROR') {
    return <GenericErrorScreen onRetry={gate.retry} />;
  }
  if (gate.status === 'PRIVACY_PENDING') {
    return <PrivacyUpdateScreen version={gate.me.privacy_notice.version} />;
  }
  return <RegularizeScreen markId={markId} />;
}

export const Route = createFileRoute('/regularizar/$markId')({
  component: RegularizeGate,
});
